import React, { useEffect, useRef, useState } from "react";
// import { useCounter } from '../../Helpers/useCounter';
// import { GETCARRITO } from '../../global/const'
import axios from "axios";
import CardProdutosCarritos from "./cardProductosCarrito";
import { useDispatch, useSelector } from "react-redux";
import * as constant from "../../global/const";

//imagenes
import carritoFoto from "../../assets/icons/carrito.svg";
import fecha from "../../assets/icons/fecha.svg";
import ubicacion from "../../assets/icons/Ubicacion.svg";
import info from "../../assets/icons/info.svg";
// import { setCarrito, setCarritoPromos } from '../../Redux/actions/CarritoPromoAction';
import Auth from "../../Helpers/auth";

//ppt-42 fecha entrega
const CardCarrito = (props) => {
  const { carState, setCarState, totalAmount, handleClickOutsideSucursal } =
    props;
  let { history } = props;
  const myRef = useRef();

  const handleClickOutside = (event) => {
    const array = event.path || (event.composedPath && event.composedPath());
    const aux = array.filter(
      (p) =>
        p.className == "bodyCarrito show" ||
        p.className == "open_carrito carritoDesktop" ||
        p.className == "open_carrito carritoMovil"
    );
    const search = event.target.innerText
      ? event.target.innerText.trim() === "Cambiar dirección"
      : false;

    if (search) {
      setCarState(false);
    } else if (!aux.length > 0) {
      if (!myRef.current.contains(event.target)) {
        setCarState(false);
      }
    }
  };

  React.useEffect(() => {
    // window.scrollTo(0, 0);
    /* if(carState)
        {
            getCarrito(props.location);
        } */
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [carState]);

  const [showTolltype, setShowTolltype] = useState(false);

  return (
    <>
      <div className="contenedorBodyCarrito">
        <div
          className="tooltip-container"
          style={showTolltype ? { display: "block" } : { display: "none" }}
        >
          <span className="tooltip-trigger"></span>
          <div className="tooltip-one">
            <div className="txt" align="left">
              <p>Ten en cuenta: </p>
              <h6>
                Al cambiar la dirección puede variar la disponibilidad y los
                precios de los productos.{" "}
              </h6>
            </div>
          </div>
        </div>
        <div
          className={
            "bodyCarrito overflow-auto scrollSlider " +
            (carState ? "show" : "hide")
          }
          ref={myRef}
        >
          <Contenido
            history={history}
            totalAmount={totalAmount}
            setShowTolltype={setShowTolltype}
          />
        </div>
      </div>
      {/* <div className="slidMovil" ref={myRef} style={carState ? SliderMovil : CloseSlider}>

                <Contenido history={history} totalAmount={totalAmount} setShowTolltype={setShowTolltype} />

            </div> */}
    </>
  );
};

const Contenido = (props) => {
  const sucursal = useSelector((state) => state.page.sucursal);
  const carritoRedux = useSelector((state) => state.carrito.carrito);
  let count = 0;
  // const dispatch = useDispatch();
  // const dispatchPromo = useDispatch();
  // const AgregarCarrito = carrito => dispatch(setCarrito(carrito));
  // const AgregarCarritoPromos = carritoPromos => dispatchPromo(setCarritoPromos(carritoPromos));
  // const user = JSON.parse(Auth.getUsuario());

  let _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {};
  // let _carritoPromos = JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};

  const { totalAmount, setShowTolltype } = props;
  let { history } = props;
  const [fechaEntrega, setFechaEntrega] = useState();

  const getFechaEntrega = () => {
    axios
      .get(
        constant.FECHAENTREGA +
          `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}`
      )
      .then((response) => {
        setFechaEntrega(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (sucursal && count == 0) {
      window.scrollTo(0, 0);
      getFechaEntrega();
      count = 1;
    } else {
      fechaEntrega && getFechaEntrega();
    }
  }, [sucursal]);

  return (
    <div className="wrapper">
      <div className="cabecera">
        <div className="titulo">
          {`Tienes ${_carrito && Object.keys(_carrito).length} producto(s) `}
        </div>
        <hr className="line" />
        <div className="direccion">
          <div className="entrega">
            <div className="direccion-container">
              <div className="textoEntrega">
                <img
                  src={ubicacion}
                  className="iconUbicacion"
                  loading="lazy"
                  alt=""
                />
                <div className="textoEntrega__info">
                  <u>
                    Entrega:{" "}
                    {sucursal && sucursal.nit + "-" + sucursal.razonsocial}{" "}
                  </u>
                  <br />
                  <u>
                    {sucursal && sucursal.direccion + " " + sucursal.ciudad}
                  </u>
                </div>
              </div>
              {JSON.parse(Auth.getUsuario()).tipoClienteUsuario == 1 && (
                <button
                  className="btnDireccion"
                  onMouseOver={() => {
                    let width = Math.max(
                      document.documentElement.clientWidth || 0,
                      window.innerWidth || 0
                    );
                    if (width > 500) {
                      setShowTolltype(true);
                    }
                  }}
                  onMouseOut={(e) => {
                    setShowTolltype(false);
                    // handleClickOutsideSucursal
                    //     &&
                    //     handleClickOutsideSucursal(e);
                  }}
                >
                  Cambiar dirección
                </button>
              )}
            </div>

            <img src={info} loading="lazy" alt="" className="info" />
          </div>
          <hr className="line" />
          <div className="fechaEntrega">
            <img src={fecha} loading="lazy" className="fecha" alt="" />
            {
              //TODO: Organizar fecha
            }
            <h2>
              Fecha de entrega:
              {
                //sucursal && sucursal.diaEntrega
              }
              {fechaEntrega ? " " + fechaEntrega.texto : ""}
            </h2>
          </div>
          <hr className="line" />
        </div>
      </div>

      <div className="productos overflow-auto scrollSlider">
        {carritoRedux ? (
          Object.keys(carritoRedux).map((codigoSku, i) => (
            <CardProdutosCarritos
              history={history}
              producto={carritoRedux[codigoSku]}
              key={i}
            />
          ))
        ) : (
          <p>Sin productos</p>
        )}
      </div>

      <div className="pie">
        {" "}
        Valor total:
        {" $" +
          new Intl.NumberFormat("de-DE", {
            numberingSystem: "latn",
            style: "decimal",
            currency: "COP",
          }).format(totalAmount)}
        <button
          className="btnPagar"
          onClick={() => (window.location.href = "./carrito")}
        >
          Ver productos{" "}
          <img
            src={carritoFoto}
            loading="lazy"
            className="fotoCarrito"
            alt=""
          />
        </button>
      </div>
      {/* <div className="falta">
                <h2>Falta $14.569 para el pedido mínimo</h2>
            </div> */}
    </div>
  );
};
export default CardCarrito;
